// /addresses/<addressId> (004 FR-036).
import { AddressFormScreen } from "@/profile/addresses/AddressFormScreen";

export default function EditAddress() {
  return <AddressFormScreen mode="edit" />;
}
